import { useQuery } from '@tanstack/react-query'

import { getCancellationThreshold } from 'services/metrics/getCancellationThreshold'
import { PROFESSIONAL_CANCELLATION_THRESHOLD } from 'settings/_reactQueryConstants'
import { CancellationThreshold } from 'models/Professional/CancellationThreshold.types'
import { isCancellationLimitReachedError } from 'utils/isCancellationLimitReachedError'

interface UseCancelLimit {
  cancelLimit?: CancellationThreshold
  isLoading: boolean
  isLimitReached: boolean
}

export function useCancelLimit(professionalUsername: string): UseCancelLimit {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [PROFESSIONAL_CANCELLATION_THRESHOLD, professionalUsername],
    queryFn: () => getCancellationThreshold(professionalUsername),
    enabled: !!professionalUsername,
    refetchOnWindowFocus: false,
    retry: false,
  })

  const isLimitReachedFromError = isError && isCancellationLimitReachedError(error)
  const isLimitReached = data ? data.remaining <= 0 : isLimitReachedFromError
  const hasThresholdUnavailable = isError && !isLimitReachedFromError

  return {
    cancelLimit: hasThresholdUnavailable ? undefined : data,
    isLoading,
    isLimitReached,
  }
}
